/* eslint-disable react/no-unknown-property */
import React, { useState, useMemo } from "react";
import SearchForm from "./SearchForm";
import { Space, Button } from "@tinper/next-ui";
/**
 *
 *
 * @param props
 */

const CollpaseLine = (props = {}) => {
  const { fieldid } = props;
  const searchForm = SearchForm.useSearchFormInstance();
  const [isHovering, setIsHovering] = useState(false);
  const collapsedConfig = useMemo(() => {
    return searchForm.collapsedConfig;
  }, [searchForm]);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const collpaseForm = () => {
    if (collapsedConfig.collapsedNailed === true) return;
    searchForm.setCollapsed((val: any) => !val);
  };

  const nailFormContainer = () => {
    searchForm.setCollapsedNailed((val: any) => !val);
  };

  return (
    <>
      <div
        className="as-searchForm-collapse"
        style={{
          display: collapsedConfig.showCollapsed ? "block" : "none"
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          className="as-searchForm-collapse-wrapper"
          style={{
            height: isHovering ? "2px" : "1px",
            backgroundImage: isHovering
              ? "linear-gradient(270deg,rgba(80,87,102,0),#505766 17%,#505766 83%,rgba(80,87,102,0))"
              : "linear-gradient(270deg, #50576600 0%, #5057664d 17%, #5057664d 83%, #50576600 100%)"
          }}
        >
          <span className="as-searchForm-collapse-button">
            <Space>
              <span uiclickable="true" onClick={collpaseForm} fieldid={fieldid ? `${fieldid}_collapse` : undefined}>
                {collapsedConfig.collapsedNailed
                  ? null
                  : (
                    <Button
                      className="as-searchForm-collapse-button-arrow"
                      icon={
                        collapsedConfig.collapsed
                          ? "uf-arrow-down"
                          : "uf-arrow-up"
                      }
                    />
                  )}
              </span>
              <span uiclickable="true" onClick={nailFormContainer} fieldid={fieldid ? `${fieldid}_collapse_nail` : undefined}>
                {collapsedConfig.collapsed
                  ? null
                  : (
                    <Button
                      className="as-searchForm-collapse-button-nail"
                      icon={
                        collapsedConfig.collapsedNailed
                          ? "uf-dingzhu_xiao"
                          : "uf-budingzhu_xiao"
                      }
                    />
                  )}
              </span>
            </Space>
          </span>
        </div>
      </div>
    </>
  );
};

export default CollpaseLine;
